module.exports = __webpack_public_path__ + "img/tender-vekop-02.ebb477e0.webp";